import MuiAvatar from '@mui/material/Avatar';
import cn from 'classnames';
import * as React from 'react';

import styles from './UserInformation.module.scss';

interface IProps {
  wrapperClassName?: string;
  avatarClassName?: string;
  name: string;
  organization?: string;
  avatarImageURL?: string;
  withBorder?: boolean;
  isMobile?: boolean;
}

const UserInformation = ({
  wrapperClassName,
  avatarClassName,
  avatarImageURL,
  name,
  withBorder = true,
  organization,
  isMobile,
}: IProps) => {
  return (
    <div className={cn(styles.userInformation, wrapperClassName)} data-action="header_user_avatar">
      <MuiAvatar
        src={avatarImageURL}
        alt={name}
        slotProps={{
          img: {
            referrerPolicy: 'no-referrer-when-downgrade',
          } as React.ImgHTMLAttributes<HTMLImageElement>,
        }}
        className={cn(avatarClassName, { [styles.border]: withBorder })}
      >
        {name?.trim()?.[0]?.toUpperCase()}
      </MuiAvatar>
      {isMobile && <span className={styles.username}>{name}</span>}
      {organization && <span className={styles.organization}>{organization}</span>}
    </div>
  );
};

export default UserInformation;
